import React from 'react';
import {Breadcrumb} from 'antd';
import {useNavigate} from 'react-router-dom';
import {ModelDTO, ModelDetailDTO} from 'hemwb-api';
import {getUrlRoute, MRAppRoutes} from '../../../router/routes';
import styles from './ModelDetailBreadcrumb.module.scss';

interface ModelDetailBreadcrumbProps {
  currentModel: ModelDTO | ModelDetailDTO | undefined | null;
  parentModel: ModelDTO | undefined;
}

/**
 * Breadcrumb navigation for ModelDetail page
 * Shows: Model Entries > [Parent Model] > Current Model
 * Parent is only shown if the current model is a child
 */
export const ModelDetailBreadcrumb: React.FC<ModelDetailBreadcrumbProps> = ({currentModel, parentModel}) => {
  const navigate = useNavigate();

  const handleModelListClick = (e: React.MouseEvent) => {
    e.preventDefault();
    navigate(MRAppRoutes.MODEL_LIST);
  };

  const items = [
    {
      title: (
        <a
          href={`#${MRAppRoutes.MODEL_LIST}`}
          onClick={handleModelListClick}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              navigate(MRAppRoutes.MODEL_LIST);
            }
          }}
        >
          Model Entries
        </a>
      ),
    },
    ...(parentModel
      ? [
          {
            title: (
              <a
                onClick={() => navigate(getUrlRoute(MRAppRoutes.MODEL_DETAIL, {uuid: parentModel.uuid}))}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    navigate(getUrlRoute(MRAppRoutes.MODEL_DETAIL, {uuid: parentModel.uuid}));
                  }
                }}
                className={styles.breadcrumbLink}
                title={parentModel.name}
              >
                {parentModel.name}
              </a>
            ),
          },
        ]
      : []),
    {
      title: (
        <span className={styles.breadcrumbLastItem} title={currentModel?.name}>
          {currentModel?.name || 'Loading...'}
        </span>
      ),
    },
  ];

  return (
    <div className={styles.breadcrumbContainer}>
      <Breadcrumb items={items} style={{fontSize: '16px'}} />
    </div>
  );
};
